/* tslint:disable:max-line-length */
import { Component } from 'react';
import { Helmet } from '@dr.pogodin/react-helmet';
import { Outlet } from 'react-router-dom';
import { CommonProvider } from '../components/providers/CommonProvider';

export default class RootNode extends Component<any, any> {
  public render() {
    return (
      <>
        <Helmet defaultTitle="World of Warcraft Rankings for Mythic+ and Raid Progress">
          <meta property="og:url" content={RIO_SITE.external_url} />
          <meta property="og:image" content={`http://${RIO_SITE.cdn_host}/images/fb_app_image.jpg`} />
          <meta property="og:title" content="World of Warcraft Rankings for Mythic+ and Raid Progress" />
          <meta property="og:type" content="website" />
          <meta
            name="description"
            content="A top World of Warcraft (WoW) Mythic+ and Raiding site featuring character & guild profiles, Mythic+ Scores, Raid Progress, Guild Recruitment, the Race to World First, and more."
          />
          <meta
            property="og:description"
            content="A top World of Warcraft (WoW) Mythic+ and Raiding site featuring character & guild profiles, Mythic+ Scores, Raid Progress, Guild Recruitment, the Race to World First, and more."
          />
          <meta property="twitter:image" content={`http://${RIO_SITE.cdn_host}/images/fb_app_image.jpg`} />
          <meta property="twitter:card" content="summary" />
          <meta property="theme-color" content="#ffbd0a" />
        </Helmet>
        <CommonProvider>
          {this.props.children || <Outlet />}
        </CommonProvider>
      </>
    );
  }
}
